module.exports = __webpack_public_path__ + "img/icon_1_2.90aac473.png";